var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keno",
    transform: "translate(-426.000000, -240.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game-header",
    transform: "translate(112.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "balance-&-menu",
    transform: "translate(224.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(90.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy-2",
    x: 0,
    y: 6,
    width: 10,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy-3",
    x: 0,
    y: 3,
    width: 10,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy-4",
    x: 0,
    y: 0,
    width: 10,
    height: 1,
    rx: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBurgerMenu);
export default __webpack_public_path__ + "static/media/icon-burger-menu.9611a2612d20cc6ca33a2bf9c8b497c3.svg";
export { ForwardRef as ReactComponent };